import type { LoaderFunction } from '@remix-run/node'

import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { addAdUnit } from '@sporza/design-system/molecules/advertisement'
import { Page } from '@sporza/design-system/organisms/page'
import { useTrackingStore } from '@sporza/tracking'
import { useEffect } from 'react'

import { setHeaders, withErrorHandling } from '~/helpers'
import bffClient from '~/services/bff'

import { headers as teamHeaders, meta as teamMeta } from './nl.$namespace.$sport.spelers.$playerPath'

export const headers = teamHeaders

export const loader: LoaderFunction = withErrorHandling(async ({ request, params }) => {
  const {
    '*': contentPart,
    namespace,
    sport,
    teamPath
  } = params
  const requestUrl = new URL(request.url)
  requestUrl.pathname = `/nl/${namespace}/${sport}/ploegen/${teamPath}`

  const content = contentPart && contentPart.endsWith('/') ? contentPart.slice(0, -1) : contentPart

  if (content) {
    if (content.indexOf('~') > -1) {
      const [pathName, contentType] = content.split('/')
      requestUrl.pathname += `${pathName}/`
      requestUrl.searchParams.set('contentType', contentType)
    } else {
      requestUrl.searchParams.set('contentType', content)
    }
  }

  const page = await bffClient.getInternalPage(requestUrl.pathname, 'aem', requestUrl.searchParams, true)

  if (!page)
    throw new Response('Not Found', { status: 404 })

  const headers = setHeaders(page)

  return json({
    page,
    designSystemBaseUrl: process.env.DESIGN_SYSTEM_BASE_URL,
    apiBaseUrl: process.env.API_BASE_URL,
    content
  }, { headers })
})

export const meta = teamMeta

export default function Slug() {
  const data = useLoaderData<any>()
  const { page, designSystemBaseUrl, apiBaseUrl, bffBaseUrl, content } = data
  const {
    digitalData,
    ebaData,
    adData
  } = page

  const initTracking = useTrackingStore((state) => state.initTracking)

  useEffect(() => {
    initTracking({ digitalData, ebaData })
    addAdUnit(adData)
  })

  return <Page
    designSystemBaseUrl={designSystemBaseUrl}
    apiBaseUrl={apiBaseUrl}
    bffBaseUrl={bffBaseUrl}
    {...page}
    title={undefined}
  />
}
